import React from 'react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { Info } from 'lucide-react'

import { NameDto } from '../../../../api/Common/Types'

interface Props {
  children?: React.ReactNode
  sizes: NameDto[]
}

export const UploadTooltip: React.FC<Props> = ({ sizes, children }) => {
  return (
    <Tooltip key='top'>
      <TooltipTrigger>{children ?? <Info size={14} />}</TooltipTrigger>
      <TooltipContent side='top'>
        Please upload an image with one of the specified sizes: <br />
        {sizes.map((x) => x.name).join(', ')}.
      </TooltipContent>
    </Tooltip>
  )
}
